import { PaginationQueryParams } from '@forwardflow/types'

// export default function applyPaginationQueryParams(
//   queryParams: PaginationQueryParams
// ) {
//   return Object.entries(queryParams).reduce((acc, [key, value]) => {
//     if (key === "filters" || key === "search" || key === "fields") {
//       return `${acc}&${value}`;
//     }

//     if (key === "includes") {
//       return `${acc}&includes=${value}`;
//     }

//     if (key === "sorts") {
//       return `${acc}&sort=${value}`;
//     }

//     if (key === "page") {
//       return `${acc}&page=${value}`;
//     }

//     if (key === "limit") {
//       return `${acc}&limit=${value}`;
//     }

//     return acc;
//   }, "");
// }

// src/helpers/utils/applyPaginationQueryParams.ts

export default function applyPaginationQueryParams(
   queryParams: PaginationQueryParams
) {
   const queryStrings: string[] = []

   Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
         const encodedKey = encodeURIComponent(key)
         const encodedValue = encodeURIComponent(String(value))
         queryStrings.push(`${encodedKey}=${encodedValue}`)
      }
   })

   return queryStrings.join('&')
}
